/* apps/web/src/branding/branding.config.ts
 *
 * THE ONE FILE A DEPLOYMENT EDITS.
 *
 * Everything else in the app consumes semantic tokens (styles/tokens.css) or
 * the <BrandLogo /> / <BrandMark /> components. Nothing else knows a hex value
 * or a logo path. Swap the fields below and the whole product follows.
 *
 * Values may also be supplied per environment through Vite env vars
 * (VITE_BRAND_*) so one image can serve several tenants without a rebuild.
 */
export interface Branding {
  /** Deployment name: the login identity panel and the document <title>. */
  brandName: string;
  /**
   * The wordmark beside the mark in the app navigation.
   *
   * Separate from `brandName` because the design's Branding tab edits exactly
   * this field ("Wordmark") and its canvas draws "Copilot" there while the
   * login screen still carries the full YazamcoOps logo.
   */
  productName: string;
  /** Full horizontal logo. Any aspect ratio — it is fitted, never stretched. */
  logo: string;
  /** Same logo reversed for dark chrome (sidebar, login identity panel). */
  logoLight: string;
  /** Compact square-ish mark for the collapsed sidebar and favicon slot. */
  logoMark: string;
  /** The mark reversed for dark chrome. */
  logoMarkLight: string;
  /** Fallback initials if a deployment supplies no mark. */
  logoMarkInitials: string;
  /** Identity + primary actions + selected states. */
  primaryColor: string;
  /** Accents, focus ring, subtle emphasis. */
  secondaryColor: string;
}

const env = import.meta.env;

export const branding: Branding = {
  brandName: env.VITE_BRAND_NAME ?? "YazamcoOps",
  productName: env.VITE_BRAND_PRODUCT_NAME ?? "Copilot",
  logo: env.VITE_BRAND_LOGO ?? "/assets/brand/logo-ops.png",
  logoLight: env.VITE_BRAND_LOGO_LIGHT ?? "/assets/brand/logo-ops-light.png",
  logoMark: env.VITE_BRAND_LOGO_MARK ?? "/assets/brand/logo-mark.png",
  logoMarkLight: env.VITE_BRAND_LOGO_MARK_LIGHT ?? "/assets/brand/logo-mark-white.png",
  logoMarkInitials: env.VITE_BRAND_INITIALS ?? "Y",
  primaryColor: env.VITE_BRAND_PRIMARY ?? "#1b3e6f",
  secondaryColor: env.VITE_BRAND_SECONDARY ?? "#4a86c8",
};
